import { Component, OnDestroy, OnInit } from '@angular/core';
// import {OutwardHeaderComponent} from '../outward-approver-header/outward-header.component'
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { OperatorFunction, Subject } from 'rxjs';
import { catchError, finalize, map,tap } from 'rxjs/operators';
import { MasterService } from 'src/app/shared/services/master.service';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { SortBy } from 'src/app/Enums/sortEnums';
import * as _ from "underscore";
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { OutwardService } from 'src/app/shared/services/outward.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import {InwardStatus} from 'src/app/Enums/inwardEnum';
import { filterData, OfficeFilter, outwardFilter } from 'src/app/shared/classes/filter';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { Office } from 'src/app/shared/classes/users';
import { Router } from '@angular/router';
import { Role } from '../../../Enum/role';
import { L2approverCommentsComponent } from '../l2approver-comments/l2approver-comments.component';
import { OutwardStatusName } from 'src/app/Enums/outwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-outward-l2approver-table',
  templateUrl: './outward-l2approver-table.component.html',
  styleUrls: ['./outward-l2approver-table.component.less']
})
export class OutwardL2approverTableComponent implements OnInit,OnDestroy {

  modalRef: BsModalRef;
  tableSetting: any;
  usersList: any;
  userModel: any;
  cityList: any;
  statusList:any;
  totalCount: number;
  InwardStatus:InwardStatus;
  currentIndex: number;
  p: number = 1;
  Roles:any;
  errorMessage: string;
  showError: boolean;
  showNoResult: boolean = false;
  displaysort: boolean = false;
  isPaginationChange: boolean = false;
  cityArray: Array<any> = new Array();
  registrationArray: Array<any> = new Array();
  statusArray: Array<any> = new Array();
  officeArray: Array<any> = new Array();
  reqId: number;
  regType: string;
  selectedRequest: any;
  duedatecomparer:string;
  emailId: string ='';

 
  filterData = {} as filterData;
  itemsperPage: number = 10;
  userName: any;
  regDateTimeFrom:any;
  regDateTimeTo:any;
  officeID: number;
  officeName:string;
  countLength: number;
  selectedOffice:any;
  data : any = [];
private service_URL: any;

private unsubscribe$ =new Subject<void>();
  registrationList: any;

  constructor(private _masterService: MasterService,
    private outwardService: OutwardService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private datePipe: DatePipe,
    private rounter:Router,private trackeromnitureservice:TrackerOmnitureService) { 
      this.filterData.page = 1;
    this.service_URL = ConstantsService;
    }

  ngOnInit(): void {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('outward-l2approver-table',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.ResetOfficesObjects();
    this.outwardService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange = false;
        this.ResetOfficesObjects();
        this.getOutwardData();
    });

        this.outwardService.refreshwithFilters
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
            this.isPaginationChange = false;
            this.ResetOfficesObjects();
            this.getOutwardData();
        });

        this.outwardService.deleteReg
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.DeleteAlert(this.reqId,this.regType);
        });

        // this.outwardService.deleteOffices
        // .pipe(takeUntil(this.unsubscribe$))
        // .subscribe(() => {
        //   this.DeleteAlert(this.officeID, this.selectedOffice);
        // });

        this.tableSetting = {
            columns: this.tableSettingColumns()
        };
        this.emailId=localStorage.getItem('email');

        //this.getUsers();
        this.getOutwardData();
  }

  ResetOfficesObjects() {
    outwardFilter.regTypeList=[];
    outwardFilter.officeList=[];
    outwardFilter.cityList=[];
    outwardFilter.statusList=[];
    this.regDateTimeFrom=null;
    this.regDateTimeTo=null;
    this.userName = '';
    this.filterData.page = 1;
}

  searchOfficeByName(val) {
    this.isPaginationChange = false;
    this.userName = val.username;
    this.filterData.page = 1;
    

    // console.log(val);
    this.regDateTimeFrom = val.fdate;
    this.regDateTimeTo = val.edate;
    this.getOutwardData();
}

PrepareUsersObj() {
  
    //   console.log(this.regDateTimeFrom.slice(0,11) + '00:00:00.000Z');
    if(this.regDateTimeFrom == null)
      { 
        this.regDateTimeFrom = new Date();
        this.regDateTimeFrom.setDate(this.regDateTimeFrom.getDate()-7);        
      }
      if(this.regDateTimeTo == null)
      {
        this.regDateTimeTo = new Date();        
      }
      let params = {
          RequestType : outwardFilter.regTypeList,
          City: outwardFilter.cityList,
          Office: outwardFilter.officeList,
          Status : outwardFilter.statusList,
          ReceivedBy : [],
          SearchByName: this.userName==undefined?"":this.userName,
          SortRequestName:"",
         // DcNumber : parseInt(this.userName),
          PageNo: this.filterData.page,
          RequestDateFrom :this.regDateTimeFrom,
          //new Date(this.datePipe.transform(this.regDateTimeFrom, 'yyyy/MM/dd').toString()).toISOString(),
          // this.regDateTimeFrom == undefined ? this.regDateTimeFrom : (this.regDateTimeFrom.slice(0,11) + '00:00:00.000Z'),
          RequestDateTo : this.regDateTimeTo ,
          LoggedinUserEmail:localStorage.getItem('email'),
          IsMyRequest:false
          //new Date(this.datePipe.transform(this.regDateTimeFrom, 'yyyy/MM/dd').toString()).toISOString()
          //this.regDateTimeTo == undefined ? this.regDateTimeTo : (this.regDateTimeTo.slice(0,11) + '00:00:00.000Z')
      };
    
      return params;
    }
    

PrepareUsersObj1() {
  //Converting Status Filter response to Boolean 
  var sArray: Array<boolean> = new Array();
  
  OfficeFilter.statusList.forEach(element => {
    element === 'Active' ? sArray.push(true) : sArray.push(false);
  });

  let params = {
      // Status: OfficeFilter.statusList,
      Status: sArray,       
      // Role: OfficeFilter.roleList,
      // Office: UsersFilterService.officesList,
      City: OfficeFilter.cityList,
      SearchByName: this.userName,
      PageNo: this.filterData.page
  };

  return params;
}

//get the city list from api
loadCityOptions(citydata: any) {
    this.registrationList = citydata;
    this.registrationArray = citydata;
    if (this.registrationArray) {
        this.registrationArray.forEach(item => {
            item.description = item.name; 
        })
    }
    if (outwardFilter.regTypeList.length == 0) {
        this.registrationArray.forEach(item => {
            item.isCheck = true;
        })
    }
    else {
        this.registrationArray.forEach(item => {
            outwardFilter.regTypeList.forEach(item1 => {
                if (item.description == item1) {
                    item.isCheck = true;
                } 
            })
        })
    }
    this.tableSetting.columns[3].isFilterIcon = true;
  }


//get the status list from api
loadStatusOptions(statusdata: any) {
    this.statusList = statusdata;
    this.statusArray = statusdata;
    if (this.statusArray) {
        this.statusArray.forEach(item => {
            item.description = item.name;
        })
    }
    if (outwardFilter.statusList.length == 0) {
        this.statusArray.forEach(item => {
            item.isCheck = true;
        })
    }
    else {
        this.statusArray.forEach(item => {
            outwardFilter.statusList.forEach(item1=>{
                if (item.description == item1) {
                    item.isCheck = true;
                } 
            })
        })
    }
    this.tableSetting.columns[4].isFilterIcon = true;
  }


setIntialPageCount(totalrecords : number)
{
    //this.totalCount = totalCount;
    this.isPaginationChange = true;
    if (totalrecords > this.itemsperPage) {
        this.countLength = this.itemsperPage;
    }
    else {
        this.countLength = totalrecords;
    }
}

deleteOffice(selectedOfficeID: number,office:Office) {
    // console.log(selectedOfficeID)
    // console.log(office)

    this.officeID = selectedOfficeID;
    this.selectedOffice=office;
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
   
// const modalsmWidth = ModalSize.Small;
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Delete office';
    this.modalRef.content.description = 'Are you sure you want to delete <b>' + this.selectedOffice.officeName + '</b>?';
    this.modalRef.content.buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Delete',
        component: ComponentName.Outward
    }
}

getOutwardData() {

    let data = this.PrepareUsersObj();

    this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.GetOutwardRequestsByFilter, data)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
//    console.log(res);
   this.duedatecomparer=new Date().toISOString();
this.usersList =res.gatepassrequests;
this.usersList.forEach(element => {
       
  const dueDate = new Date(this.duedatecomparer);
  const revisedDate = new Date(element.revisedDate);

  const timeDifference = revisedDate.getTime() - dueDate.getTime();

  const daysDifference = timeDifference / (1000 * 3600 * 24);
  const hoursDifference = Math.abs(timeDifference / (1000 * 3600));

  const days = Math.abs(Math.round(daysDifference));
  
  if (days === 1 || days === 2 || hoursDifference <= 48) {
      element.duedatebeforetwodays = true;
  } else {
      element.duedatebeforetwodays = false;
  }

});
    this.totalCount=res.totalRecords;
    this.loadCityOptions(res.type);
    this.loadStatusOptions(res.status); 
   
    if(!this.isPaginationChange){this.setIntialPageCount(this.totalCount);}
    

    })

    }

    loadreqTypeOption(reqtypedata: any) {
        this.registrationArray = reqtypedata;
       // this.checkFilterOptions(this.registrationArray);
    }

    checkFilterOptions(filterArray, filterList) {
        if (filterArray) {
            filterArray.forEach(item => {
                item.description = item.name;
            })

            // _.each(filterArray, function (item) {
            //     item.description = item.name;
            // })
        }
        if (filterList.length == 0) {
            filterArray.forEach(item =>{
                item.isCheck = true;
            })

            // _.each(filterArray, function (item) {
            //     item.isCheck = true;
            // })
        }
        else {
            filterArray.forEach(item => {
                filterList.forEach(item1 => {
                    if (item.description == item1) {
                        item.isCheck = true;
                    } 
                })
            })


            // _.each(filterArray, function (item) {
            //     _.each(filterList, function (item1) {
            //         if (item.description == item1) {
            //             item.isCheck = true;
            //         }
            //     })
            // })
        }
    }




    detailedIOnfo(val){
// this.rounter.navigate(['ViewOutward']);
 this.rounter.navigate(['/ViewOutwardL2Approver', val]); 
//  console.log(val);
}
checkFilterApplied(val) {
  this.isPaginationChange = false;
  if (val) {
      this.filterData.sortBy = OfficeFilter.sortBy;
      this.filterData.sortOrder = OfficeFilter.sortOrder;
      this.filterData.page = 1;
      this.p = 1;
      this.checkFilterValue();
      this.getOutwardData();
  } else {
      this.usersList = [];
  }
}

checkFilterValue() {
  this.tableSetting.columns.forEach(item => {
      if (OfficeFilter.sortBy != item.sortBy) {
          item.isFilterApplied = false;
      }
  })
}
changeCurrentPage(event) {
  //this.isPaginationChange = true;
  this.filterData.page = event.page;
  if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
      this.countLength = this.filterData.page * this.itemsperPage
  }
  else {
      this.countLength = this.totalCount;
  }
  this.getOutwardData();
}

  showSortingPopup(obj) {

    _.each(this.tableSetting.columns, function (item) {
        if (item.Id != obj.Id) {
            item.displaysort = false;
        }
    })
    obj.displaysort = !obj.displaysort;
}


hideDropdowns() {
  _.each(this.tableSetting.columns, function (item) {
      item.displaysort = false;
  })
}

closeDropDown() {
  _.each(this.usersList, function (item) {
      item.showAssigneeDropdown = false;
      item.showStatusDropdown = false;
  })

}

  tableSettingColumns() {
    return [
        
        {
            Id: 1,
            title: "Request ID",
            classes: "ui_size_md",
            //isSortable: true,
            isResNameSortN: true,
            cityDropdown: true,
            isFilterApplied: false
            //displaysort: false,
            
        },
        // {
        //     Id: 2,
        //     title: "G.P. No.",
        //     classes: "ui_size_md",
        //     //isResNameSortN: true,
        //     isFilterApplied: false,
        //     displaysort: false,
        //     isFilterIcon: false
        // },
        {
           
          Id: 2,
          title: "Request Name",
          classes: "ui_size_md_small",
          isSortable: true,
          statusDropdown: true,               
          isFilterApplied: false,
          displaysort: false,
          isOnlyFilter: true,
          isFilterIcon: false
        },
        {
            Id:3,
            title: "Request Type",
            classes: "ui_size_md_small",            
            isSortable: true,
            requestTypeDropDown: true,
            //isResNameSortN: true,
            //filterWrapper: "event-type-dropdown",
            sortBy: SortBy.Reg,
            isFilterApplied: false,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true
        },
        {
          
            Id:4,
            title: "Status",
            classes: "ui_size_md_small",            
            isSortable: true,
            statusDropdown: true,
            //isResNameSortN: true,
            //filterWrapper: "event-type-dropdown",
            sortBy: SortBy.Status,
            isFilterApplied: false,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true

        },
        {
            Id: 5,
            title: "Request Date & Time",
            classes: "ui_size_md",
            isSortable: false,
            isFilterApplied: false,
            sortBy: SortBy.RequestDate,
            displaysort: false,
            isOnlyFilter: true,
            isFilterIcon: true
        },
        {
            Id: 6,
            title: "Due Date & Time",
            classes: "ui_size_md",
            isSortable: false,
            isFilterApplied: false,
            sortBy: SortBy.DueDate,
            displaysort: false,
            isOnlyFilter: false,
            isFilterIcon: false
        },
        {
            Id:7,
            title: "Requested By",
            classes: "ui_size_md_small",            
            isSortable: true,
            statusDropdown: true,
            //isResNameSortN: true,
            //filterWrapper: "event-type-dropdown",
            sortBy: SortBy.RequestedBy,
            isFilterApplied: false,
            displaysort: false,
            isOnlyFilter: false,
            isFilterIcon: false

        },
        // ,
        // {
        //     Id:8,
        //     title: "City",            
        //     //isSortable: true,
        //     isResNameSortN: true,
        //     sortBy: SortBy.City,
        //     cityDropdown:true,
        //     isFilterApplied: false,
        //     displaysort: false,
        //     //isOnlyFilter:true,
        //     isFilterIcon: true,
        //     isStaticColumn: false, 
        //     //isSelected : false,
        //     isSortable : false
        // },
        // {
        //     Id:9,
        //     title: "Office",            
        //     //isSortable: true,
        //     isResNameSortN: true,
        //     sortBy: SortBy.Office,
        //     officeDropdown: true,
        //     isFilterApplied: false,
        //     displaysort:false,
        //     //isOnlyFilter:true,
        //     isFilterIcon: true,
        //     isStaticColumn: false,
        //     //isSelected : false,
        //     isSortable : false
        // }

    ];
}

DeleteAlert(selectedOfficeID: number, office:any) {
    if(office.status = false){
        this.toast.error("Office was already deleted");
        return ;
    }
    let url = this.service_URL.OfficeDetails.DeleteOfficeId + '/' + selectedOfficeID;       
    // let data = {
    //   id: selectedOfficeID
    // };
        this._dataContextService.get<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
            // console.log(res);
            if (res=="3") {                
                //ToastrComponent.success("Successfully deleted!");                
                this.toast.error("This office refered in user");
                
            }
            else if(res=="1"){
                this.toast.error("Office was deleted");
                //this.isPaginationChange = false;
                this.getOutwardData();
            }
            else{
                this.toast.error("Some thing went on wrong..")
            }
            
        })
    }

ngOnDestroy(){
  this.unsubscribe$.next();
  this.unsubscribe$.complete();


}


onReject(selectedRequest:any){
    this.modalRef = this.modalService.show(L2approverCommentsComponent,{
        initialState : {
          selectedRequest : selectedRequest
        }
      })
      this.modalRef.setClass(ModalSize.Large);
   }
   
   onAccept(status : any,requestId:any, serialNumber: any){
    let newstatus=0;
    if(status==OutwardStatusName.Created){
      newstatus=5;
    }
    if(status==OutwardStatusName.LAapprover1){
      newstatus=7;
    }
    let params = {
        statusId : newstatus,
        requestId : requestId,
        Updatedby: this.emailId,
        L2ApprovedDateTime: new Date().toISOString()
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "L1 Approved";
    statusChangeAudit.newValue = "L2 Approved";

    auditData.push(statusChangeAudit);
    
      this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.UpdateStatus,params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if(res == 1){
          this.toast.success("Request Approved by L2 Approver");
          
          // Saving Data in Audit Trail - only on success
          // let auditParams = {
          //   actionPerformed : "Status Change",
          //   actionPerformedOn : "Outward",
          //   changedBy : localStorage.getItem('email'),
          //   dateChanged : new Date(),
          //   primaryKey : serialNumber,
          //   generalInformation : [],
          //   material : [],
          //   statusChange: auditData
          // };

          // console.log('Calling audit trail API:', this.service_URL.AuditTrail.savetransactionaudittrail);
          // console.log('Audit trail params:', auditParams);

          // this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail, auditParams)
          // .pipe(takeUntil(this.unsubscribe$))
          // .subscribe(
          //   (auditRes) => {
          //     console.log('Audit trail saved successfully:', auditRes);
          //   },
          //   (auditErr) => {
          //     console.error('Error saving audit trail:', auditErr);
          //     this.toast.warning('Approval saved but audit trail failed');
          //   },
          //   () => {
          //     // Delay reload to ensure audit trail completes
          //     setTimeout(() => {
          //       window.location.reload();
          //     }, 500);
          //   }
          // );
          
          // Reload page directly without audit trail
          window.location.reload();
        }
        else{
          this.toast.error("Something went wrong");
        }
      },
      (err) => {
        console.error('Error updating status:', err);
        this.toast.error("Something went wrong");
      })
    //   window.location.reload();
  }

}
